import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';

import groupByTime from '../groupByTime';

function parseStatusCodesRawData(rawData: AggregatedMetrics.StatusCodesResult) {
  const groupedByTime = groupByTime<AggregatedMetrics.StatusCodesResult>(rawData);

  const statusCodesValues: Record<string, number[]> = {};

  groupedByTime.forEach((item, index) => {
    item.data.forEach((datapoint) => {
      if (!Array.isArray(statusCodesValues[datapoint.status_code]))
        statusCodesValues[datapoint.status_code] = Array(groupedByTime.length).fill(0);
      statusCodesValues[datapoint.status_code][index] = datapoint.status_code_count;
    });
  });

  const statusCodesValuesList = Object.entries(statusCodesValues);

  return {
    statusCodesValuesList,
  };
}

export default parseStatusCodesRawData;
